import { render, staticRenderFns } from "./FormularioDadosGerais.vue?vue&type=template&id=7403891a&"
import script from "./FormularioDadosGerais.vue?vue&type=script&lang=js&"
export * from "./FormularioDadosGerais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports